var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};
var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
    i,
    q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;
  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }
  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};
import { Scheduler } from 'async-scheduler';
export function rawPageIterator(pagination, callPerformer, iteratorOptions) {
  return __asyncGenerator(this, arguments, function rawPageIterator_1() {
    var perPage, concurrency, firstResponse, _i, _a, item, totalCount, limiter, promises, _loop_1, offset, response, _b, _c, item;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          perPage = (iteratorOptions === null || iteratorOptions === void 0 ? void 0 : iteratorOptions.perPage) || pagination.defaultLimit;
          if (perPage > pagination.maxLimit) {
            throw new Error("perPage option cannot exceed maximum value of ".concat(pagination.maxLimit));
          }
          concurrency = (iteratorOptions === null || iteratorOptions === void 0 ? void 0 : iteratorOptions.concurrency) || 1;
          if (concurrency > 10) {
            throw new Error('concurrency option cannot exceed maximum value of 10');
          }
          return [4 /*yield*/, __await(callPerformer({
            limit: perPage,
            offset: 0
          }))];
        case 1:
          firstResponse = _d.sent();
          _i = 0, _a = firstResponse.data;
          _d.label = 2;
        case 2:
          if (!(_i < _a.length)) return [3 /*break*/, 6];
          item = _a[_i];
          return [4 /*yield*/, __await(item)];
        case 3:
          return [4 /*yield*/, _d.sent()];
        case 4:
          _d.sent();
          _d.label = 5;
        case 5:
          _i++;
          return [3 /*break*/, 2];
        case 6:
          totalCount = firstResponse.meta.total_count;
          limiter = new Scheduler(concurrency);
          promises = [];
          _loop_1 = function _loop_1(offset) {
            promises.push(limiter.enqueue(function () {
              return callPerformer({
                limit: perPage,
                offset: offset
              });
            }));
          };
          for (offset = perPage; offset < totalCount; offset += perPage) {
            _loop_1(offset);
          }
          _d.label = 7;
        case 7:
          if (!(promises.length > 0)) return [3 /*break*/, 14];
          return [4 /*yield*/, __await(promises.shift())];
        case 8:
          response = _d.sent();
          _b = 0, _c = response.data;
          _d.label = 9;
        case 9:
          if (!(_b < _c.length)) return [3 /*break*/, 13];
          item = _c[_b];
          return [4 /*yield*/, __await(item)];
        case 10:
          return [4 /*yield*/, _d.sent()];
        case 11:
          _d.sent();
          _d.label = 12;
        case 12:
          _b++;
          return [3 /*break*/, 9];
        case 13:
          return [3 /*break*/, 7];
        case 14:
          return [2 /*return*/];
      }
    });
  });
}
export function warnOnPageQueryParam(queryParams) {
  if (queryParams && 'page' in queryParams) {
    console.warn('Passing a `page` query param on paged iterators has no effect: use the `perPage` option instead.');
  }
}